export const WA_NUMBER = "6287767607705";
export const WA_DISPLAY = "+62 877 6760 7705";
export const EMAIL = "sales@cressco.co.id";
export const SITE = "cressco.co.id";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};
